import { useTheme, ThemeProvider } from '@mui/material/styles';
import { lightTheme } from '../../Themes/LightCustomTheme';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { Box } from '@mui/system';
import { CssBaseline } from '@mui/material';
import { TopBar } from '../TopBar/TopBar';
import { Outlet } from 'react-router-dom';
import { LoginPage } from '../../Pages/LoginPage';

export const App = () => {
  const theme = useTheme();

  return (
    <ThemeProvider theme={ lightTheme }>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <TopBar />
        <Box component="main" sx={{ flexGrow: 1, p: 3 }} style={{ paddingTop: `calc(${theme.mixins.toolbar.minHeight}px + 20px)` }}>
          <AuthenticatedTemplate>
            <Outlet />
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <LoginPage />
          </UnauthenticatedTemplate>
        </Box>
      </Box>
    </ThemeProvider>
  );
}